import { TextProjectSettingDto } from "app/ApiClient";
import { LoadingState } from "types";

export type LanguageVariableState = {
  createLanguageVariableLoadingState: LoadingState;
  textProjectSetting: TextProjectSettingDto | null;
  languageVariableLoadingState: LoadingState;
  languageDetectionStatus:LoadingState; 
  projectId: number; 
  encodedVersionId?: string;
  languageVariableName? : string;
};

export const initialLanguageVariableState: LanguageVariableState = {
  createLanguageVariableLoadingState: LoadingState.idle,
  textProjectSetting: null,
  languageVariableLoadingState: LoadingState.idle,
  languageDetectionStatus : LoadingState.idle,
  projectId: 0, 
};
